import { StorageCreateWarehouse } from '@features/storage-create-warehouse';
import { StorageFilter } from '@features/storage-filter';
import { StorageModeSelect } from '@features/storage-mode-select';
import { StorageSearchField } from '@features/storage-search';
import styles from './styles.module.css';

export const StorageControls = () => (
  <div className={styles.controls}>
    <StorageModeSelect />
    <StorageSearchField />
    <StorageFilter />
    <StorageCreateWarehouse />
  </div>
);
